import { useContext, useEffect, useState } from "react";
import Configurationcontext from "../../Context/ConfigrationContext/Configurationcontext";
import configurationConstants from "../../apis/configuration/configurationConstants";
import ConfirmationModal from "./ConfirmationModal";
import AddAuditAreaModal from "./AddAuditAreaModal";
import CustomCard from "./CustomCard";
import configurationAPI from "../../apis/configuration/configurationAPI";
import Swal from "sweetalert2";
import CopyFeedbackCategoriesModal from "./CopyFeedbackCategoriesModal";

const FeedbackCategories = ({
  location,
  clientCurrentId,
  selectedLocation,
  fetchConfigurationData,
  setSuccess,
  setFeedbackCategoryDropdownsData,
  invalidateFeedbackdropdowns,
  setInvalidateFeedbackdropdowns,
  handleApplyDefaultCategories
}) => {
  const data = useContext(Configurationcontext);
  const configurationProvider = useContext(Configurationcontext);
  const primaryDiagnosis = "primary_diagnosis";
  const secondaryDiagnosis = "secondary_diagnosis";
  const procedures = "procedures";
  const edEmLevel = "ed_em_level";
  const modifier = "modifier";
  const poa = "poa";
  const drug = "drug";
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [deleteParams, setDeleteParams] = useState({});
  const [showAddAuditAreaModal, setAddAuditAreaModal] = useState(false);
  const [auditAreas, setAuditAreas] = useState([]);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [copyCategoryKey, setCopyCategoryKey] = useState("");
  const [copyCategoryHeader, setCopyCategoryHeader] = useState("")

  const fetchNewAuditAreas = async () => {
    try {
      const response = await configurationAPI.getAuditAreas({
        clientId: clientCurrentId,
        locationId: selectedLocation
      });
      if (response.success) {
        setAuditAreas(response.data);
      }
    } catch (error) {
      window.toastr.error("Something went wrong");
    }
  };


  const handleApplyCopiedCategories = (copyCategoryKey, categoriesArray) => {
    configurationProvider.setSubmitData(prev => {
      const next = {
        ...prev,
        [configurationConstants.FEEDBACK_CONFIGURATION]: {
          ...prev[configurationConstants.FEEDBACK_CONFIGURATION],
          [copyCategoryKey]: categoriesArray,
        },
      }

      if(copyCategoryKey === configurationConstants.FEEDBACK_TYPES){
        next[configurationConstants.AUDITING_CONFIGURATION] = {
          ...prev[configurationConstants.AUDITING_CONFIGURATION],
          [configurationConstants.FEEDBACK_TYPES]: categoriesArray,
        };
      }

      return next; 
    });
    window.toastr.success("Categories copied (not yet saved)");
  };

  const openCopyModalForCategory = (categoryKey, headerKey) => {
    setCopyCategoryKey(categoryKey);
    setCopyCategoryHeader(headerKey);
    setShowCopyModal(true);
  }

  useEffect(() => {
    if (clientCurrentId && selectedLocation) {
      fetchNewAuditAreas();
    }
    // eslint-disable-next-line
  }, [clientCurrentId, selectedLocation, invalidateFeedbackdropdowns]);

  return (
    <>
      <div className="col-12 d-flex justify-content-end align-items-center mb-4">
        <div className="text-danger fs-7 px-4"> <i className="fas fa-exclamation-triangle text-danger" /> <span>Changes done in existing feedback category will impact all charts including the audited ones.</span></div>
        {(clientCurrentId && selectedLocation) &&( 
        <div className="d-flex flex-col gap-2 " >
          <button
          className="btn btn-primary me-2"
          onClick={() => {
            if(auditAreas?.length >= 5){
              window.toastr.error("You can't add more than 5 audit areas");
              return;
            }
            setAddAuditAreaModal(true);
          }}
        >+ Add Audit Area</button>
        
          <button
              type="button"
              className="btn btn-light-primary"
              onClick={()=>handleApplyDefaultCategories("FEEDBACK_CONFIGURATION")}
            >
              Apply Default Categories
          </button>
        </div>
        )}
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="card card-flush mb-4">
            <div className="card-header minimize">
              <div className="card-title">
                <h4>Primary Diagnosis</h4>
              </div>
              <div className="card-toolbar mt-0">
                <button className="btn btn-icon btn-sm btn-light-gray justify-content-center">
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body pt-0">
              <div
                className=""
                data-kt-ecommerce-catalog-add-product="auto-options"
              >
                <div id="kt_ecommerce_add_product_options">
                  <div className="form-group">
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className="d-flex flex-column gap-3"
                    >
                      {location?.length !== 0
                        ? data.configprimaryDiagnosis.map((item, i) => (
                            <div
                              data-repeater-item=""
                              className="form-group d-flex flex-wrap align-items-center gap-5"
                              key={i}
                            >
                              <input
                                type="text"
                                className="form-control mw-100 w-85"
                                name="product_option_value"
                                value={
                                  (configurationProvider.editedData[
                                    configurationConstants
                                      .FEEDBACK_CONFIGURATION
                                  ][configurationConstants.PRIMARY_DIAGNOSIS] ??
                                    {})[item.id] ?? item.feedback_name
                                }
                                placeholder={item.feedback_name}
                                onChange={(e) =>
                                  configurationProvider.onEditFieldChange(
                                    configurationConstants.FEEDBACK_CONFIGURATION,
                                    configurationConstants.PRIMARY_DIAGNOSIS,
                                    item.id,
                                    e.target.value,
                                  )
                                }
                              />
                              <button
                                type="button"
                                data-repeater-delete=""
                                className="btn btn-sm btn-icon btn-light-danger"
                                onClick={() => {
                                  setDeleteParams({
                                    clientCurrentId,
                                    id: item?.id,
                                    config_option: item?.feedback_name,
                                    LocationId: item?.LocationId,
                                    type: primaryDiagnosis,
                                  });
                                  setShowConfirmationModal(true);
                                }}
                              >
                                <span className="svg-icon svg-icon-1">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="7.05025"
                                      y="15.5356"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-45 7.05025 15.5356)"
                                      fill="currentColor"
                                    />
                                    <rect
                                      x="8.46447"
                                      y="7.05029"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(45 8.46447 7.05029)"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          ))
                        : ""}
                    </div>
                  </div>
                  <div className="form-group mt-5">
                    <div className="form-group">
                      <div
                        data-repeater-list="kt_ecommerce_add_product_options"
                        className="d-flex flex-column gap-3"
                      >
                        {(
                          configurationProvider.submitData[
                            configurationConstants.FEEDBACK_CONFIGURATION
                          ].primfeed ?? []
                        ).map((item, i) => {
                          return (
                            <div id="kt_ecommerce_add_product_options">
                              <div id="process">
                                <div className="applicant-fields">
                                  <div className="form-group">
                                    <div
                                      data-repeater-list="kt_ecommerce_add_product_options"
                                      className="d-flex flex-column gap-3"
                                    >
                                      <div
                                        data-repeater-item=""
                                        className="form-group d-flex flex-wrap align-items-center gap-5"
                                      >
                                        <input
                                          type="text"
                                          className="form-control mw-100 w-85"
                                          value={
                                              (configurationProvider.submitData[
                                                configurationConstants
                                                  .FEEDBACK_CONFIGURATION
                                              ][configurationConstants.PRIMARY_DIAGNOSIS] ?? {})[
                                                item.id
                                              ] ?? item
                                            }
                                          onChange={(e) =>
                                            configurationProvider.onFieldChange(
                                              configurationConstants.FEEDBACK_CONFIGURATION,
                                              configurationConstants.PRIMARY_DIAGNOSIS,
                                              i,
                                              e.target.value,
                                            )
                                          }
                                        />
                                        <button
                                          type="button"
                                          data-repeater-delete=""
                                          className="btn btn-sm btn-icon btn-light-danger"
                                          onClick={() =>
                                            configurationProvider.onDeleteClick(
                                              configurationConstants.FEEDBACK_CONFIGURATION,
                                              configurationConstants.PRIMARY_DIAGNOSIS,
                                              i,
                                            )
                                          }
                                        >
                                          <span className="svg-icon svg-icon-1">
                                            <svg
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <rect
                                                opacity="0.5"
                                                x="7.05025"
                                                y="15.5356"
                                                width="12"
                                                height="2"
                                                rx="1"
                                                transform="rotate(-45 7.05025 15.5356)"
                                                fill="currentColor"
                                              />
                                              <rect
                                                x="8.46447"
                                                y="7.05029"
                                                width="12"
                                                height="2"
                                                rx="1"
                                                transform="rotate(45 8.46447 7.05029)"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-5 d-flex flex-col gap-4">
                    <button
                      type="button"
                      data-repeater-create=""
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        configurationProvider.onAddClick(
                          configurationConstants.FEEDBACK_CONFIGURATION,
                          configurationConstants.PRIMARY_DIAGNOSIS,
                        )
                      }
                    >
                      <span className="svg-icon svg-icon-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            opacity="0.5"
                            x="11"
                            y="18"
                            width="12"
                            height="2"
                            rx="1"
                            transform="rotate(-90 11 18)"
                            fill="currentColor"
                          />
                          <rect
                            x="6"
                            y="11"
                            width="12"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      Add another
                    </button>
                     <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => openCopyModalForCategory(configurationConstants.PRIMARY_DIAGNOSIS, "Primary Diagonosis")}
                      >
                        <i className="fas fa-copy me-1"></i>
                        Copy from other
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="card card-flush mb-4">
            <div className="card-header minimize">
              <div className="card-title">
                <h4>Secondary Diagnosis</h4>
              </div>
              <div className="card-toolbar mt-0">
                <button className="btn btn-icon btn-sm btn-light-gray justify-content-center ">
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body pt-0">
              <div
                className=""
                data-kt-ecommerce-catalog-add-product="auto-options"
              >
                <div id="kt_ecommerce_add_product_options">
                  <div className="form-group">
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className="d-flex flex-column gap-3"
                    >
                      {location?.length !== 0
                        ? data.configSecondaryDiagnosis.map((item, i) => (
                            <div
                              data-repeater-item=""
                              className="form-group d-flex flex-wrap align-items-center gap-5"
                              key={i}
                            >
                              <input
                                type="text"
                                className="form-control mw-100 w-85"
                                name="product_option_value"
                                value={
                                  (configurationProvider.editedData[
                                    configurationConstants
                                      .FEEDBACK_CONFIGURATION
                                  ][
                                    configurationConstants.SECONDARY_DIAGNOSIS
                                  ] ?? {})[item.id] ?? item.feedback_name
                                }
                                placeholder={item.feedback_name}
                                onChange={(e) =>
                                  configurationProvider.onEditFieldChange(
                                    configurationConstants.FEEDBACK_CONFIGURATION,
                                    configurationConstants.SECONDARY_DIAGNOSIS,
                                    item.id,
                                    e.target.value,
                                  )
                                }
                              />
                              <button
                                type="button"
                                data-repeater-delete=""
                                className="btn btn-sm btn-icon btn-light-danger"
                                onClick={() => {
                                  setDeleteParams({
                                    clientCurrentId,
                                    id: item?.id,
                                    config_option: item?.feedback_name,
                                    LocationId: item?.LocationId,
                                    type: secondaryDiagnosis,
                                  });
                                  setShowConfirmationModal(true);
                                }}
                              >
                                <span className="svg-icon svg-icon-1">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="7.05025"
                                      y="15.5356"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-45 7.05025 15.5356)"
                                      fill="currentColor"
                                    />
                                    <rect
                                      x="8.46447"
                                      y="7.05029"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(45 8.46447 7.05029)"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          ))
                        : ""}
                    </div>
                    <div className="form-group mt-5">
                      <div className="form-group">
                        <div
                          data-repeater-list="kt_ecommerce_add_product_options"
                          className="d-flex flex-column gap-3"
                        >
                          {(
                            configurationProvider.submitData[
                              configurationConstants.FEEDBACK_CONFIGURATION
                            ].sec_diag_feed ?? []
                          ).map((item, i) => {
                            return (
                              <div id="kt_ecommerce_add_product_options">
                                <div id="process">
                                  <div className="applicant-fields">
                                    <div className="form-group">
                                      <div
                                        data-repeater-list="kt_ecommerce_add_product_options"
                                        className="d-flex flex-column gap-3"
                                      >
                                        <div
                                          data-repeater-item=""
                                          className="form-group d-flex flex-wrap align-items-center gap-5"
                                        >
                                          <input
                                            type="text"
                                            className="form-control mw-100 w-85"
                                            value={
                                              (configurationProvider.submitData[
                                                configurationConstants
                                                  .FEEDBACK_CONFIGURATION
                                              ][configurationConstants.SECONDARY_DIAGNOSIS] ?? {})[
                                                item.id
                                              ] ?? item
                                            }
                                            onChange={(e) =>
                                              configurationProvider.onFieldChange(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.SECONDARY_DIAGNOSIS,
                                                i,
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <button
                                            type="button"
                                            data-repeater-delete=""
                                            className="btn btn-sm btn-icon btn-light-danger"
                                            onClick={() =>
                                              configurationProvider.onDeleteClick(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.SECONDARY_DIAGNOSIS,
                                                i,
                                              )
                                            }
                                          >
                                            <span className="svg-icon svg-icon-1">
                                              <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  opacity="0.5"
                                                  x="7.05025"
                                                  y="15.5356"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(-45 7.05025 15.5356)"
                                                  fill="currentColor"
                                                />
                                                <rect
                                                  x="8.46447"
                                                  y="7.05029"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(45 8.46447 7.05029)"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-5 d-flex flex-col gap-4">
                    <button
                      type="button"
                      data-repeater-create=""
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        configurationProvider.onAddClick(
                          configurationConstants.FEEDBACK_CONFIGURATION,
                          configurationConstants.SECONDARY_DIAGNOSIS,
                        )
                      }
                    >
                      <span className="svg-icon svg-icon-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            opacity="0.5"
                            x="11"
                            y="18"
                            width="12"
                            height="2"
                            rx="1"
                            transform="rotate(-90 11 18)"
                            fill="currentColor"
                          />
                          <rect
                            x="6"
                            y="11"
                            width="12"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      Add another
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => openCopyModalForCategory(configurationConstants.SECONDARY_DIAGNOSIS, "Secondary Diagonosis")}
                      >
                        <i className="fas fa-copy me-1"></i>
                        Copy from other
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="card card-flush mb-4">
            <div className="card-header minimize">
              <div className="card-title">
                <h4>Procedures</h4>
              </div>
              <div className="card-toolbar mt-0">
                <button className="btn btn-icon btn-sm btn-light-gray justify-content-center ">
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body pt-0">
              <div
                className=""
                data-kt-ecommerce-catalog-add-product="auto-options"
              >
                <div id="kt_ecommerce_add_product_options">
                  <div className="form-group">
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className="d-flex flex-column gap-3"
                    >
                      {location?.length !== 0
                        ? data.configProcedures.map((item, i) => (
                            <div
                              data-repeater-item=""
                              className="form-group d-flex flex-wrap align-items-center gap-5"
                              key={i}
                            >
                              <input
                                type="text"
                                className="form-control mw-100 w-85"
                                name="product_option_value"
                                value={
                                  (configurationProvider.editedData[
                                    configurationConstants
                                      .FEEDBACK_CONFIGURATION
                                  ][configurationConstants.PROCEDURES] ?? {})[
                                    item.id
                                  ] ?? item.feedback_name
                                }
                                placeholder={item.feedback_name}
                                onChange={(e) =>
                                  configurationProvider.onEditFieldChange(
                                    configurationConstants.FEEDBACK_CONFIGURATION,
                                    configurationConstants.PROCEDURES,
                                    item.id,
                                    e.target.value,
                                  )
                                }
                              />
                              <button
                                type="button"
                                data-repeater-delete=""
                                className="btn btn-sm btn-icon btn-light-danger"
                                onClick={() => {
                                  setDeleteParams({
                                    clientCurrentId,
                                    id: item?.id,
                                    config_option: item?.feedback_name,
                                    LocationId: item?.LocationId,
                                    type: procedures,
                                  });
                                  setShowConfirmationModal(true);
                                }}
                              >
                                <span className="svg-icon svg-icon-1">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="7.05025"
                                      y="15.5356"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-45 7.05025 15.5356)"
                                      fill="currentColor"
                                    />
                                    <rect
                                      x="8.46447"
                                      y="7.05029"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(45 8.46447 7.05029)"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          ))
                        : ""}
                    </div>
                    <div className="form-group mt-5">
                      <div className="form-group">
                        <div
                          data-repeater-list="kt_ecommerce_add_product_options"
                          className="d-flex flex-column gap-3"
                        >
                          {(
                            configurationProvider.submitData[
                              configurationConstants.FEEDBACK_CONFIGURATION
                            ].procedure_feed ?? []
                          ).map((item, i) => {
                            return (
                              <div id="kt_ecommerce_add_product_options">
                                <div id="process">
                                  <div className="applicant-fields">
                                    <div className="form-group">
                                      <div
                                        data-repeater-list="kt_ecommerce_add_product_options"
                                        className="d-flex flex-column gap-3"
                                      >
                                        <div
                                          data-repeater-item=""
                                          className="form-group d-flex flex-wrap align-items-center gap-5"
                                        >
                                          <input
                                            type="text"
                                            className="form-control mw-100 w-85"
                                            value={
                                              (configurationProvider.submitData[
                                                configurationConstants
                                                  .FEEDBACK_CONFIGURATION
                                              ][configurationConstants.PROCEDURES] ?? {})[
                                                item.id
                                              ] ?? item
                                            }
                                            onChange={(e) =>
                                              configurationProvider.onFieldChange(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.PROCEDURES,
                                                i,
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <button
                                            type="button"
                                            data-repeater-delete=""
                                            className="btn btn-sm btn-icon btn-light-danger"
                                            onClick={() =>
                                              configurationProvider.onDeleteClick(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.PROCEDURES,
                                                i,
                                              )
                                            }
                                          >
                                            <span className="svg-icon svg-icon-1">
                                              <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  opacity="0.5"
                                                  x="7.05025"
                                                  y="15.5356"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(-45 7.05025 15.5356)"
                                                  fill="currentColor"
                                                />
                                                <rect
                                                  x="8.46447"
                                                  y="7.05029"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(45 8.46447 7.05029)"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-5 d-flex flex-col gap-4">
                    <button
                      type="button"
                      data-repeater-create=""
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        configurationProvider.onAddClick(
                          configurationConstants.FEEDBACK_CONFIGURATION,
                          configurationConstants.PROCEDURES,
                        )
                      }
                    >
                      <span className="svg-icon svg-icon-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            opacity="0.5"
                            x="11"
                            y="18"
                            width="12"
                            height="2"
                            rx="1"
                            transform="rotate(-90 11 18)"
                            fill="currentColor"
                          />
                          <rect
                            x="6"
                            y="11"
                            width="12"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      Add another
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => openCopyModalForCategory(configurationConstants.PROCEDURES, "Procedures")}
                      >
                        <i className="fas fa-copy me-1"></i>
                        Copy from other
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="card card-flush mb-4">
            <div className="card-header minimize">
              <div className="card-title">
                <h4>ED/EM Level</h4>
              </div>
              <div className="card-toolbar mt-0">
                <button className="btn btn-icon btn-sm btn-light-gray justify-content-center ">
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body pt-0">
              <div
                className=""
                data-kt-ecommerce-catalog-add-product="auto-options"
              >
                <div id="kt_ecommerce_add_product_options">
                  <div className="form-group">
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className="d-flex flex-column gap-3"
                    >
                      {location?.length !== 0
                        ? data.configEd.map((item, i) => (
                            <div
                              data-repeater-item=""
                              className="form-group d-flex flex-wrap align-items-center gap-5"
                              key={i}
                            >
                              <input
                                type="text"
                                className="form-control mw-100 w-85"
                                name="product_option_value"
                                value={
                                  (configurationProvider.editedData[
                                    configurationConstants
                                      .FEEDBACK_CONFIGURATION
                                  ][configurationConstants.EDM_LEVEL] ?? {})[
                                    item.id
                                  ] ?? item.feedback_name
                                }
                                placeholder={item.feedback_name}
                                onChange={(e) =>
                                  configurationProvider.onEditFieldChange(
                                    configurationConstants.FEEDBACK_CONFIGURATION,
                                    configurationConstants.EDM_LEVEL,
                                    item.id,
                                    e.target.value,
                                  )
                                }
                              />
                              <button
                                type="button"
                                data-repeater-delete=""
                                className="btn btn-sm btn-icon btn-light-danger"
                                onClick={() => {
                                  setDeleteParams({
                                    clientCurrentId,
                                    id: item?.id,
                                    config_option: item?.feedback_name,
                                    LocationId: item?.LocationId,
                                    type: edEmLevel,
                                  });
                                  setShowConfirmationModal(true);
                                }}
                              >
                                <span className="svg-icon svg-icon-1">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="7.05025"
                                      y="15.5356"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-45 7.05025 15.5356)"
                                      fill="currentColor"
                                    />
                                    <rect
                                      x="8.46447"
                                      y="7.05029"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(45 8.46447 7.05029)"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          ))
                        : ""}
                    </div>
                    <div className="form-group mt-5">
                      <div className="form-group">
                        <div
                          data-repeater-list="kt_ecommerce_add_product_options"
                          className="d-flex flex-column gap-3"
                        >
                          {(
                            configurationProvider.submitData[
                              configurationConstants.FEEDBACK_CONFIGURATION
                            ].ed_em_feed ?? []
                          ).map((item, i) => {
                            return (
                              <div id="kt_ecommerce_add_product_options">
                                <div id="process">
                                  <div className="applicant-fields">
                                    <div className="form-group">
                                      <div
                                        data-repeater-list="kt_ecommerce_add_product_options"
                                        className="d-flex flex-column gap-3"
                                      >
                                        <div
                                          data-repeater-item=""
                                          className="form-group d-flex flex-wrap align-items-center gap-5"
                                        >
                                          <input
                                            type="text"
                                            className="form-control mw-100 w-85"
                                            value={
                                              (configurationProvider.submitData[
                                                configurationConstants
                                                  .FEEDBACK_CONFIGURATION
                                              ][configurationConstants.EDM_LEVEL] ?? {})[
                                                item.id
                                              ] ?? item
                                            }
                                            onChange={(e) =>
                                              configurationProvider.onFieldChange(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.EDM_LEVEL,
                                                i,
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <button
                                            type="button"
                                            data-repeater-delete=""
                                            className="btn btn-sm btn-icon btn-light-danger"
                                            onClick={() =>
                                              configurationProvider.onDeleteClick(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.EDM_LEVEL,
                                                i,
                                              )
                                            }
                                          >
                                            <span className="svg-icon svg-icon-1">
                                              <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  opacity="0.5"
                                                  x="7.05025"
                                                  y="15.5356"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(-45 7.05025 15.5356)"
                                                  fill="currentColor"
                                                />
                                                <rect
                                                  x="8.46447"
                                                  y="7.05029"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(45 8.46447 7.05029)"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-5 d-flex flex-col gap-4">
                    <button
                      type="button"
                      data-repeater-create=""
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        configurationProvider.onAddClick(
                          configurationConstants.FEEDBACK_CONFIGURATION,
                          configurationConstants.EDM_LEVEL,
                        )
                      }
                    >
                      <span className="svg-icon svg-icon-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            opacity="0.5"
                            x="11"
                            y="18"
                            width="12"
                            height="2"
                            rx="1"
                            transform="rotate(-90 11 18)"
                            fill="currentColor"
                          />
                          <rect
                            x="6"
                            y="11"
                            width="12"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      Add another
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => openCopyModalForCategory(configurationConstants.EDM_LEVEL, "ED/EM Level")}
                      >
                        <i className="fas fa-copy me-1"></i>
                        Copy from other
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="card card-flush mb-4">
            <div className="card-header minimize">
              <div className="card-title">
                <h4>Modifier</h4>
              </div>
              <div className="card-toolbar mt-0">
                <button className="btn btn-icon btn-sm btn-light-gray justify-content-center ">
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body pt-0">
              <div
                className=""
                data-kt-ecommerce-catalog-add-product="auto-options"
              >
                <div id="kt_ecommerce_add_product_options">
                  <div className="form-group">
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className="d-flex flex-column gap-3"
                    >
                      {location?.length !== 0
                        ? data.configModifier.map((item, i) => (
                            <div
                              data-repeater-item=""
                              className="form-group d-flex flex-wrap align-items-center gap-5"
                              key={i}
                            >
                              <input
                                type="text"
                                className="form-control mw-100 w-85"
                                name="product_option_value"
                                value={
                                  (configurationProvider.editedData[
                                    configurationConstants
                                      .FEEDBACK_CONFIGURATION
                                  ][configurationConstants.MODIFIER] ?? {})[
                                    item.id
                                  ] ?? item.feedback_name
                                }
                                placeholder={item.feedback_name}
                                onChange={(e) =>
                                  configurationProvider.onEditFieldChange(
                                    configurationConstants.FEEDBACK_CONFIGURATION,
                                    configurationConstants.MODIFIER,
                                    item.id,
                                    e.target.value,
                                  )
                                }
                              />
                              <button
                                type="button"
                                data-repeater-delete=""
                                className="btn btn-sm btn-icon btn-light-danger"
                                onClick={() => {
                                  setDeleteParams({
                                    clientCurrentId,
                                    id: item?.id,
                                    config_option: item?.feedback_name,
                                    LocationId: item?.LocationId,
                                    type: modifier,
                                  });
                                  setShowConfirmationModal(true);
                                }}
                              >
                                <span className="svg-icon svg-icon-1">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="7.05025"
                                      y="15.5356"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-45 7.05025 15.5356)"
                                      fill="currentColor"
                                    />
                                    <rect
                                      x="8.46447"
                                      y="7.05029"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(45 8.46447 7.05029)"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          ))
                        : ""}
                    </div>
                    <div className="form-group mt-5">
                      <div className="form-group">
                        <div
                          data-repeater-list="kt_ecommerce_add_product_options"
                          className="d-flex flex-column gap-3"
                        >
                          {(
                            configurationProvider.submitData[
                              configurationConstants.FEEDBACK_CONFIGURATION
                            ].modifier_feed ?? []
                          ).map((item, i) => {
                            return (
                              <div id="kt_ecommerce_add_product_options">
                                <div id="process">
                                  <div className="applicant-fields">
                                    <div className="form-group">
                                      <div
                                        data-repeater-list="kt_ecommerce_add_product_options"
                                        className="d-flex flex-column gap-3"
                                      >
                                        <div
                                          data-repeater-item=""
                                          className="form-group d-flex flex-wrap align-items-center gap-5"
                                        >
                                          <input
                                            type="text"
                                            className="form-control mw-100 w-85"
                                            value={
                                              (configurationProvider.submitData[
                                                configurationConstants
                                                  .FEEDBACK_CONFIGURATION
                                              ][configurationConstants.MODIFIER] ?? {})[
                                                item.id
                                              ] ?? item
                                            }
                                            onChange={(e) =>
                                              configurationProvider.onFieldChange(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.MODIFIER,
                                                i,
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <button
                                            type="button"
                                            data-repeater-delete=""
                                            className="btn btn-sm btn-icon btn-light-danger"
                                            onClick={() =>
                                              configurationProvider.onDeleteClick(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.MODIFIER,
                                                i,
                                              )
                                            }
                                          >
                                            <span className="svg-icon svg-icon-1">
                                              <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  opacity="0.5"
                                                  x="7.05025"
                                                  y="15.5356"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(-45 7.05025 15.5356)"
                                                  fill="currentColor"
                                                />
                                                <rect
                                                  x="8.46447"
                                                  y="7.05029"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(45 8.46447 7.05029)"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-5 d-flex flex-col gap-4">
                    <button
                      type="button"
                      data-repeater-create=""
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        configurationProvider.onAddClick(
                          configurationConstants.FEEDBACK_CONFIGURATION,
                          configurationConstants.MODIFIER,
                        )
                      }
                    >
                      <span className="svg-icon svg-icon-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            opacity="0.5"
                            x="11"
                            y="18"
                            width="12"
                            height="2"
                            rx="1"
                            transform="rotate(-90 11 18)"
                            fill="currentColor"
                          />
                          <rect
                            x="6"
                            y="11"
                            width="12"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      Add another
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => openCopyModalForCategory(configurationConstants.MODIFIER, "Modifier")}
                      >
                        <i className="fas fa-copy me-1"></i>
                        Copy from other
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="card card-flush mb-4">
            <div className="card-header minimize">
              <div className="card-title">
                <h4>POA Indicator</h4>
              </div>
              <div className="card-toolbar mt-0">
                <button className="btn btn-icon btn-sm btn-light-gray justify-content-center ">
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body pt-0">
              <div
                className=""
                data-kt-ecommerce-catalog-add-product="auto-options"
              >
                <div id="kt_ecommerce_add_product_options">
                  <div className="form-group">
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className="d-flex flex-column gap-3"
                    >
                      {location?.length !== 0
                        ? data.configPOA.map((item, i) => (
                            <div
                              data-repeater-item=""
                              className="form-group d-flex flex-wrap align-items-center gap-5"
                              key={i}
                            >
                              <input
                                type="text"
                                className="form-control mw-100 w-85"
                                name="product_option_value"
                                value={
                                  (configurationProvider.editedData[
                                    configurationConstants
                                      .FEEDBACK_CONFIGURATION
                                  ][configurationConstants.POA] ?? {})[
                                    item.id
                                  ] ?? item.feedback_name
                                }
                                placeholder={item.feedback_name}
                                onChange={(e) =>
                                  configurationProvider.onEditFieldChange(
                                    configurationConstants.FEEDBACK_CONFIGURATION,
                                    configurationConstants.POA,
                                    item.id,
                                    e.target.value,
                                  )
                                }
                              />
                              <button
                                type="button"
                                data-repeater-delete=""
                                className="btn btn-sm btn-icon btn-light-danger"
                                onClick={() => {
                                  setDeleteParams({
                                    clientCurrentId,
                                    id: item?.id,
                                    config_option: item?.feedback_name,
                                    LocationId: item?.LocationId,
                                    type: poa,
                                  });
                                  setShowConfirmationModal(true);
                                }}
                              >
                                <span className="svg-icon svg-icon-1">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="7.05025"
                                      y="15.5356"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-45 7.05025 15.5356)"
                                      fill="currentColor"
                                    />
                                    <rect
                                      x="8.46447"
                                      y="7.05029"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(45 8.46447 7.05029)"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          ))
                        : ""}
                    </div>
                    <div className="form-group mt-5">
                      <div className="form-group">
                        <div
                          data-repeater-list="kt_ecommerce_add_product_options"
                          className="d-flex flex-column gap-3"
                        >
                          {(
                            configurationProvider.submitData[
                              configurationConstants.FEEDBACK_CONFIGURATION
                            ].poa_feed ?? []
                          ).map((e, i) => {
                            return (
                              <div id="kt_ecommerce_add_product_options">
                                <div id="process">
                                  <div className="applicant-fields">
                                    <div className="form-group">
                                      <div
                                        data-repeater-list="kt_ecommerce_add_product_options"
                                        className="d-flex flex-column gap-3"
                                      >
                                        <div
                                          data-repeater-item=""
                                          className="form-group d-flex flex-wrap align-items-center gap-5"
                                        >
                                          <input
                                            type="text"
                                            className="form-control mw-100 w-85"
                                            onChange={(e) =>
                                              configurationProvider.onFieldChange(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.POA,
                                                i,
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <button
                                            type="button"
                                            data-repeater-delete=""
                                            className="btn btn-sm btn-icon btn-light-danger"
                                            onClick={() =>
                                              configurationProvider.onDeleteClick(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.POA,
                                                i,
                                              )
                                            }
                                          >
                                            <span className="svg-icon svg-icon-1">
                                              <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  opacity="0.5"
                                                  x="7.05025"
                                                  y="15.5356"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(-45 7.05025 15.5356)"
                                                  fill="currentColor"
                                                />
                                                <rect
                                                  x="8.46447"
                                                  y="7.05029"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(45 8.46447 7.05029)"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-5">
                    <button
                      type="button"
                      data-repeater-create=""
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        configurationProvider.onAddClick(
                          configurationConstants.FEEDBACK_CONFIGURATION,
                          configurationConstants.POA,
                        )
                      }
                    >
                      <span className="svg-icon svg-icon-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            opacity="0.5"
                            x="11"
                            y="18"
                            width="12"
                            height="2"
                            rx="1"
                            transform="rotate(-90 11 18)"
                            fill="currentColor"
                          />
                          <rect
                            x="6"
                            y="11"
                            width="12"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      Add another
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="card card-flush mb-4">
            <div className="card-header minimize">
              <div className="card-title">
                <h4>Drug Value</h4>
              </div>
              <div className="card-toolbar mt-0">
                <button className="btn btn-icon btn-sm btn-light-gray justify-content-center ">
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body pt-0">
              <div
                className=""
                data-kt-ecommerce-catalog-add-product="auto-options"
              >
                <div id="kt_ecommerce_add_product_options">
                  <div className="form-group">
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className="d-flex flex-column gap-3"
                    >
                      {location?.length !== 0
                        ? data.configDrug.map((item, i) => (
                            <div
                              data-repeater-item=""
                              className="form-group d-flex flex-wrap align-items-center gap-5"
                              key={i}
                            >
                              <input
                                type="text"
                                className="form-control mw-100 w-85"
                                name="product_option_value"
                                value={
                                  (configurationProvider.editedData[
                                    configurationConstants
                                      .FEEDBACK_CONFIGURATION
                                  ][configurationConstants.DRUG] ?? {})[
                                    item.id
                                  ] ?? item.feedback_name
                                }
                                placeholder={item.feedback_name}
                                onChange={(e) =>
                                  configurationProvider.onEditFieldChange(
                                    configurationConstants.FEEDBACK_CONFIGURATION,
                                    configurationConstants.DRUG,
                                    item.id,
                                    e.target.value,
                                  )
                                }
                              />
                              <button
                                type="button"
                                data-repeater-delete=""
                                className="btn btn-sm btn-icon btn-light-danger"
                                onClick={() => {
                                  setDeleteParams({
                                    clientCurrentId,
                                    id: item?.id,
                                    config_option: item?.feedback_name,
                                    LocationId: item?.LocationId,
                                    type: drug,
                                  });
                                  setShowConfirmationModal(true);
                                }}
                              >
                                <span className="svg-icon svg-icon-1">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="7.05025"
                                      y="15.5356"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-45 7.05025 15.5356)"
                                      fill="currentColor"
                                    />
                                    <rect
                                      x="8.46447"
                                      y="7.05029"
                                      width="12"
                                      height="2"
                                      rx="1"
                                      transform="rotate(45 8.46447 7.05029)"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          ))
                        : ""}
                    </div>
                    <div className="form-group mt-5">
                      <div className="form-group">
                        <div
                          data-repeater-list="kt_ecommerce_add_product_options"
                          className="d-flex flex-column gap-3"
                        >
                          {(
                            configurationProvider.submitData[
                              configurationConstants.FEEDBACK_CONFIGURATION
                            ].drug_feed ?? []
                          ).map((e, i) => {
                            return (
                              <div id="kt_ecommerce_add_product_options">
                                <div id="process">
                                  <div className="applicant-fields">
                                    <div className="form-group">
                                      <div
                                        data-repeater-list="kt_ecommerce_add_product_options"
                                        className="d-flex flex-column gap-3"
                                      >
                                        <div
                                          data-repeater-item=""
                                          className="form-group d-flex flex-wrap align-items-center gap-5"
                                        >
                                          <input
                                            type="text"
                                            className="form-control mw-100 w-85"
                                            onChange={(e) =>
                                              configurationProvider.onFieldChange(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.DRUG,
                                                i,
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <button
                                            type="button"
                                            data-repeater-delete=""
                                            className="btn btn-sm btn-icon btn-light-danger"
                                            onClick={() =>
                                              configurationProvider.onDeleteClick(
                                                configurationConstants.FEEDBACK_CONFIGURATION,
                                                configurationConstants.DRUG,
                                                i,
                                              )
                                            }
                                          >
                                            <span className="svg-icon svg-icon-1">
                                              <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  opacity="0.5"
                                                  x="7.05025"
                                                  y="15.5356"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(-45 7.05025 15.5356)"
                                                  fill="currentColor"
                                                />
                                                <rect
                                                  x="8.46447"
                                                  y="7.05029"
                                                  width="12"
                                                  height="2"
                                                  rx="1"
                                                  transform="rotate(45 8.46447 7.05029)"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-5">
                    <button
                      type="button"
                      data-repeater-create=""
                      className="btn btn-sm btn-light"
                      onClick={() =>
                        configurationProvider.onAddClick(
                          configurationConstants.FEEDBACK_CONFIGURATION,
                          configurationConstants.DRUG,
                        )
                      }
                    >
                      <span className="svg-icon svg-icon-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            opacity="0.5"
                            x="11"
                            y="18"
                            width="12"
                            height="2"
                            rx="1"
                            transform="rotate(-90 11 18)"
                            fill="currentColor"
                          />
                          <rect
                            x="6"
                            y="11"
                            width="12"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      Add another
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {(auditAreas).map((auditArea) => (
          <div key={auditArea.id} className="col-lg-6 col-md-6 col-sm-12 col-12">
            <CustomCard
              auditAreaId={auditArea.id}
              auditArea={auditArea}
              setFeedbackCategoryDropdownsData={setFeedbackCategoryDropdownsData}
              invalidateFeedbackdropdowns={invalidateFeedbackdropdowns}
              setInvalidateFeedbackdropdowns={setInvalidateFeedbackdropdowns}
            />
          </div>))}
      </div>

      {showConfirmationModal && (
        <ConfirmationModal
          deleteParams={deleteParams}
          setDeleteParams={setDeleteParams}
          showConfirmationModal={showConfirmationModal}
          setShowConfirmationModal={setShowConfirmationModal}
          fetchConfigurationData={fetchConfigurationData}
        />
      )}
      {showAddAuditAreaModal && (
        <AddAuditAreaModal
          onHide={() => setAddAuditAreaModal(false)}
          show={showAddAuditAreaModal}
          locationId={selectedLocation}
          clientId={clientCurrentId}
          setSuccess={setSuccess}
          fetchNewAuditAreas={fetchNewAuditAreas}
        />
      )}
      {showCopyModal && (
        <CopyFeedbackCategoriesModal
          show={showCopyModal}
          onHide={() => setShowCopyModal(false)}
          categoryKey={copyCategoryKey}
          categoryHeader={copyCategoryHeader}
          onApplyCategories={handleApplyCopiedCategories}
        />
      )}

    </>
  );
};
export default FeedbackCategories;
